import React from 'react';
import marketAxess from '../assets/Market-Axess-logo.png';
import tradeweb from '../assets/Trade-Web-logo.webp';
import bloomberg from '../assets/Bloomberg-logo.png';
import finra from '../assets/Finra-logo.webp';
import pershing from '../assets/Pershing-logo.png';
import Bondscom from '../assets/Bonds.com-logo.png';
import iceTmcBonds from '../assets/Ice-Tmc-Bonds-logo.png';
import lseg from '../assets/LSEG-logo.png';
import mb from '../assets/Mb-logo.png';
import miraeAsset from '../assets/Mirae-Asset-logo.png';
import msrb from '../assets/MSRB-logo.png';
import rcb from '../assets/RCB-logo.png'
import truemid from '../assets/Truemid-logo.png'
import Wedbush from '../assets/Wedbush-logo.png'
import Bondpoint from '../assets/Bondpoint-logo.jpg'
import Mifid from '../assets/Mifid-logo.jpg'
import OpenYield from '../assets/OpenYield-logo.jpg'

const EcosystemCompatibility = () => {
    // ========== ROW 1 LOGOS - Edit logos for the first scrolling row below ==========
    const row1Logos = [
        { id: 1, name: 'Bondpoint', src: Bondpoint },
        { id: 2, name: 'MiFID II', src: Mifid },
        { id: 3, name: 'Bonds.com', src: Bondscom },
        { id: 4, name: 'Market Axess', src: marketAxess },
        { id: 5, name: 'MB', src: mb },
        { id: 6, name: 'Bloomberg', src: bloomberg },
        { id: 7, name: 'Tradeweb', src: tradeweb },
        { id: 8, name: 'Truemid', src: truemid },
    ];

    // ========== ROW 2 LOGOS - Edit logos for the second scrolling row below ==========
    const row2Logos = [
        { id: 1, name: 'Pershing', src: pershing },
        { id: 2, name: 'Wedbush', src: Wedbush },
        { id: 3, name: 'MIRAE ASSET', src: miraeAsset },
        { id: 4, name: 'RBC', src: rcb },
        { id: 5, name: 'FINRA', src: finra },
        { id: 6, name: 'MSRB', src: msrb },
        { id: 7, name: 'LSEG', src: lseg },
        { id: 8, name: 'ICE TMC Bonds', src: iceTmcBonds },
        { id: 9, name: 'OpenYield', src: OpenYield },
    ];

    return (
        <section className="w-full bg-[#070E21] py-20 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 mb-12">
                <h2 className="font-oswald text-white text-3xl md:text-4xl font-bold uppercase text-center tracking-wide">
                    COMPATIBLE WITH YOUR EXISTING ECOSYSTEM<span className="text-gray-500">*</span>
                </h2>
            </div>

            {/* Row 1 - First Scrolling Row */}
            <div className="relative w-full overflow-hidden flex mb-6">
                {/* Set 1 */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 min-w-full flex-shrink-0 items-center">
                    {row1Logos.map((logo) => (
                        <div
                            key={`row1-set1-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center p-6 w-[240px] md:w-[280px] h-[100px] md:h-[120px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                {/* Set 2 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 min-w-full flex-shrink-0 items-center" aria-hidden="true">
                    {row1Logos.map((logo) => (
                        <div
                            key={`row1-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center p-6 w-[240px] md:w-[280px] h-[100px] md:h-[120px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Row 2 - Second Scrolling Row */}
            <div className="relative w-full overflow-hidden flex">
                {/* Set 1 */}
                <div className="flex animate-scroll ml-40 gap-6 md:gap-8 pr-6 md:pr-8 min-w-full flex-shrink-0 items-center">
                    {row2Logos.map((logo) => (
                        <div
                            key={`row2-set1-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center p-6 w-[240px] md:w-[280px] h-[100px] md:h-[120px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                {/* Set 2 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 min-w-full flex-shrink-0 items-center" aria-hidden="true">
                    {row2Logos.map((logo) => (
                        <div
                            key={`row2-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center p-6 w-[240px] md:w-[280px] h-[100px] md:h-[120px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Disclaimer Text */}
            <div className="max-w-7xl mx-auto px-4 mt-8 text-center">
                <p className="text-gray-400 text-sm italic">
                    *All product names, logos, brands, and trademarks featured above are the property of their respective owners.
                </p>
            </div>
        </section>
    );
};

export default EcosystemCompatibility;
